import { createClient } from '@supabase/supabase-js';

import { env } from './env';

if (!env.supabaseUrl || !env.supabaseAnonKey) {
  // Hard-fail with a useful message — the admin tool is unusable without
  // auth, no point letting the user click around.
  // eslint-disable-next-line no-console
  console.error(
    '[web-social] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY are missing. ' +
      'Copy `.env.example` to `.env.local` and fill them in.',
  );
}

export const supabase = createClient(env.supabaseUrl, env.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
